import { GenericStorePropertyChange } from "@/types/store-property-change";

export function generateTransactionKeyFromGenericStorePropertyChange(
  storePropertyChange: GenericStorePropertyChange,
  prefix = ""
): string | undefined {
  const transactionBundlingOptions =
    storePropertyChange.meta?.transactionBundling;

  if (transactionBundlingOptions && "disable" in transactionBundlingOptions) {
    return undefined;
  }

  return `${prefix}:PATH:${storePropertyChange.path}:${transactionBundlingOptions?.bundlingKeySuffix}`;
}
